import { Button, DropdownMenuTrigger } from '@herit-fe/heritage-ui';
import { ChevronDown, type LucideIcon } from 'lucide-react';
import { useIsCompact } from './use-is-compact';

/**
 * 반응형 드롭다운 트리거(공통) — pc: `라벨 + 캐럿(▾)` outline 버튼 / non-pc(lg 미만): **아이콘만 정사각**(aria-label 보존).
 * base-ui `Menu.Trigger` 의 render 로 트리거 element 를 heritage `Button` 으로 교체(native button 아님·중첩 아님).
 * `<DropdownMenu>` 안에서 `<DropdownMenuContent>` 와 함께 사용. size 로 옆 컨트롤(조회조건=default / select=sm)과 높이 맞춤.
 */
export function ResponsiveDropdownTrigger({
  label,
  icon: Icon,
  size = 'default',
}: {
  label: string;
  icon: LucideIcon;
  size?: 'sm' | 'default';
}) {
  const compact = useIsCompact();
  const square = size === 'sm' ? 'w-8 px-0' : 'w-9 px-0';
  return (
    <DropdownMenuTrigger
      render={
        compact ? (
          <Button variant="outline" size={size} className={square} aria-label={label} />
        ) : (
          <Button variant="outline" size={size} />
        )
      }
    >
      {compact ? (
        <Icon />
      ) : (
        <>
          {label}
          <ChevronDown />
        </>
      )}
    </DropdownMenuTrigger>
  );
}
